
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1xupv_hlyea_94",
  "wizard": "awsui_wizard_1xupv_hlyea_107",
  "refresh": "awsui_refresh_1xupv_hlyea_107",
  "small-container": "awsui_small-container_1xupv_hlyea_114",
  "navigation": "awsui_navigation_1xupv_hlyea_123",
  "number": "awsui_number_1xupv_hlyea_185",
  "circle": "awsui_circle_1xupv_hlyea_201",
  "title": "awsui_title_1xupv_hlyea_209",
  "active": "awsui_active_1xupv_hlyea_238",
  "disabled": "awsui_disabled_1xupv_hlyea_249",
  "enabled": "awsui_enabled_1xupv_hlyea_259",
  "form": "awsui_form_1xupv_hlyea_301",
  "form-header": "awsui_form-header_1xupv_hlyea_307",
  "background": "awsui_background_1xupv_hlyea_318",
  "form-header-content": "awsui_form-header-content_1xupv_hlyea_330",
  "form-component": "awsui_form-component_1xupv_hlyea_334",
  "hidden": "awsui_hidden_1xupv_hlyea_348",
  "collapsed-steps": "awsui_collapsed-steps_1xupv_hlyea_352",
  "collapsed-steps-hidden": "awsui_collapsed-steps-hidden_1xupv_hlyea_357",
  "form-header-component-wrapper": "awsui_form-header-component-wrapper_1xupv_hlyea_361",
  "form-header-component": "awsui_form-header-component_1xupv_hlyea_361",
  "navigation-link": "awsui_navigation-link_1xupv_hlyea_374",
  "navigation-link-item": "awsui_navigation-link-item_1xupv_hlyea_375",
  "navigation-link-label": "awsui_navigation-link-label_1xupv_hlyea_376",
  "navigation-link-active": "awsui_navigation-link-active_1xupv_hlyea_380",
  "navigation-link-disabled": "awsui_navigation-link-disabled_1xupv_hlyea_385",
  "cancel-button": "awsui_cancel-button_1xupv_hlyea_389",
  "previous-button": "awsui_previous-button_1xupv_hlyea_390",
  "primary-button": "awsui_primary-button_1xupv_hlyea_391",
  "skip-to-button": "awsui_skip-to-button_1xupv_hlyea_392",
  "action-buttons": "awsui_action-buttons_1xupv_hlyea_396"
};
  